// Note: This route is protected by a content security policy.
//       See the headers function in next.config.js.
import SignInPage from './lib/SignInPage';
import { graphQLWrapper } from '@zoopla/apollo';

const SignInPageWithGraphQL = graphQLWrapper(SignInPage);

export { SignInPageWithGraphQL as SignInPage };
